import React, {useState} from 'react';
import dayjs from "dayjs";
import {formatCurrency} from "../../utils/monetary";
import {Button, Popconfirm, Table} from "antd";
import {ApartmentOutlined, DeleteOutlined} from "@ant-design/icons";
import {useDispatch} from "react-redux";
import {deleteBooking} from "../../store/actions/BookingAction";
import BookingModal from "./BookingModal";

function BookingTable({openOptionsTab, loading, bookings}) {

	// L'état ne gère plus juste un booléen, mais la réservation entière sélectionnée.
	const [selectedBooking, setSelectedBooking] = useState(null);
	const dispatch = useDispatch();

	const handleDelete = async (id) => {
		await dispatch(deleteBooking(id))
	}

	// Cette fonction met à jour l'état avec la réservation cliquée, ce qui ouvrira la modale.
	const showModal = (booking) => {
		setSelectedBooking(booking);
	};

	// Cette fonction réinitialise l'état à null, ce qui fermera la modale.
	const handleCloseModal = (requete) => {
		setSelectedBooking(null);
		if (requete && openOptionsTab) {
			openOptionsTab(); // ouvre/active l’onglet "Options" (28)
		}
	};

	const columns = [
		{
			title: "Période réservé",
			//dataIndex: "start_at",
			key: "period",
			width: "20%",
			render: (_, record) => {
				return `Du ${record.start_at} au ${record.end_at}`;
			},
			sorter: (a, b) => {
				// Convertir les dates DD/MM/YYYY en objets dayjs pour comparaison
				const dateA = dayjs(a.start_at, "DD/MM/YYYY");
				const dateB = dayjs(b.start_at, "DD/MM/YYYY");
				return dateB.unix() - dateA.unix();
			},
			defaultSortOrder: "descend",
		},
		{
			title: "Locataire",
			dataIndex: "tenant",
			key: "tenant",
			//width: "20%",
			align: "left",
			render: (tenant) => `${tenant?.personne?.nom} ${tenant?.personne?.prenom}`,
		},
		{
			title: "Immeuble",
			dataIndex: "building",
			key: "building",
			//width: "20%",
			align: "left",
			render: (building) => building?.nom,
		},
		{
			title: "Montant location",
			dataIndex: "price",
			key: "price",
			width: "10%",
			align: "right",
			render: (price) => formatCurrency(price),
		},
		{
			title: "Acompte locataire",
			dataIndex: "deposit_tenant",
			key: "deposit_tenant",
			width: "12%",
			align: "right",
			render: (deposit_tenant) => formatCurrency(deposit_tenant),
		},
		{
			title: "",
			key: "action",
			width: "5%",
			align: "right",
			render: (_, record) => (
				<div style={{ display: "flex", gap:8, justifyContent: "flex-end" }}>
					<Button
						type="primary"
						icon={<ApartmentOutlined />}
						onClick={() => showModal(record)}
						/>
					<Popconfirm
						title="Supprimer une réservation ?"
						description="Êtes-vous sûr de vouloir supprimer cette réservation ?"
						onConfirm={() => handleDelete(record.id)}
						okText="Oui"
						cancelText="Non"
						okButtonProps={{ danger: true }}
					>
						<Button
							type="default"
							icon={<DeleteOutlined />}
							size="middle"
						/>
					</Popconfirm>
				</div>
			),
		},
	];

	return(
		<div style={{ marginBottom: 20 }}>
			<BookingModal
				open={!!selectedBooking}
				onClose={handleCloseModal}
				booking={selectedBooking}
			/>
			<Table
				dataSource={bookings || []}
				columns={columns}
				loading={loading}
				rowKey="id"
				pagination={false}
				locale={{
					emptyText: "Aucune réservation en attente.",
				}}
				size="middle"
			/>
		</div>
	);
}

export default BookingTable;